import { TableWrapper } from '../styled-components.js'
import PropTypes from 'prop-types'

const TableRoot = ({ children }) => {
  return <TableWrapper>{children}</TableWrapper>
}

TableRoot.propTypes = {
  children: PropTypes.node.isRequired
}

export default TableRoot
